import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api/axiosInstance";

// ----------- Async Thunk (GET OTO settings) -----------
export const fetchOtoSettings = createAsyncThunk(
  "otoSettings/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get("/dashboard/general-settings/oto-settings");
      return response.data.data.settings;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ----------- Slice -----------
const otoSettingsSlicer = createSlice({
  name: "otoSettings",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearOtoSettingsState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOtoSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOtoSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOtoSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearOtoSettingsState } = otoSettingsSlicer.actions;
export default otoSettingsSlicer.reducer;
